import { useAnalytics } from '@app/analytics/use-analytics';
import { Tab, TabGroup } from '@app/components/tab-group';
import { FLAG_ENABLE_CONTENT_LIBRARY_ORG_DASHBOARD } from '@app/features/analytics/constants';
import { useFlags } from '@app/hooks/use-flags';
import { FLAG_CHANGE_CONTENT_LIBRARY_DEFAULT_TAB } from '@app/utilities/flags';
import { useTranslation } from '@hopin-team/provider-translation';
import React, { ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface ContentPageProps {
  children: ReactNode;
  contextMenu?: ReactNode;
}

type TabType = 'hubs' | 'library';

export const Layout = ({ children, contextMenu }: ContentPageProps) => {
  const location = useLocation();
  const selectedTab = location.pathname.split('/').pop() || '';
  const { t } = useTranslation();
  const flags = useFlags();
  const enableCHLibraryOrgDashboard =
    flags?.[FLAG_ENABLE_CONTENT_LIBRARY_ORG_DASHBOARD];
  const isLibraryDefaultTab = Boolean(
    flags?.[FLAG_CHANGE_CONTENT_LIBRARY_DEFAULT_TAB],
  );

  const tabs: TabType[] = isLibraryDefaultTab
    ? ['library', 'hubs']
    : ['hubs', 'library'];
  const defaultIndex = tabs.indexOf(selectedTab as TabType);

  const { track } = useAnalytics();
  const handleTabClick = (menuItem: TabType) => {
    track('ch_nav_menu_item_clicked', { menuItem });
  };

  return (
    <div className="mx-auto max-w-[90rem] p-6 h-[calc(100vh-4rem)]">
      <div className="flex items-center justify-between">
        <TabGroup defaultIndex={defaultIndex}>
          {tabs.map(tab => {
            if (tab === 'library' && !enableCHLibraryOrgDashboard) {
              return null;
            }
            return (
              <Tab
                key={tab}
                as={Link}
                to={`../${tab}`}
                onClick={() => handleTabClick(tab)}
              >
                {t(`topbar.${tab}`)}
              </Tab>
            );
          })}
        </TabGroup>
        <div className="flex items-center gap-4">
          {contextMenu ? contextMenu : null}
        </div>
      </div>

      <div className="mt-6 h-full">{children}</div>
    </div>
  );
};
